import {
  FETCH_PRODUCT_CATEGORY_LIST,
  RESET_PRODUCT_CATEGORY_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const productCategoryListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_CATEGORY_LIST:
      return { list: action.payload, others: action.others };
    case RESET_PRODUCT_CATEGORY_LIST: {
      return initialState;
    }
    default:
      return state;
  }
};

export default productCategoryListReducer;
